import { forwardRef, type SVGProps } from 'react';

export type FigmaStarFilledIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaStarFilledIcon = forwardRef<SVGSVGElement, FigmaStarFilledIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g clip-path="url(#a)">
      <path
        d="M8 0.390137L9.87882 6.21586L16 6.20248L11.04 9.78959L12.9443 15.607L8 11.9983L3.05573 15.607L4.96 9.78959L0 6.20248L6.12118 6.21586L8 0.390137Z"
        fill="currentColor"
        fillOpacity="0.8"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
));

FigmaStarFilledIcon.displayName = 'FigmaStarFilledIcon';
